import { RBAustriaController } from './rbAustria.controller';
import template from './rbAustria.html';

export const createRequestRBAustriaComponent = {
  name: 'createRequestRbAustria',
  restrict: 'E',
  template,
  controller: RBAustriaController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '=',
  },
};
